import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Relay42Service } from '@mnz-core/services/relay42.service';
import * as appActions from '@mnz-store/actions/app.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { filter, map, tap } from 'rxjs/operators';

@Injectable()
export class RouterEffects {
  constructor(
    private readonly _actions$: Actions,
    private readonly _relay42: Relay42Service,
    private readonly _router: Router
  ) {}

  routerNavigated$ = createEffect(() =>
    this._actions$.pipe(
      ofType<RouterNavigatedAction>(ROUTER_NAVIGATED),
      tap(({ payload }) => this._relay42.publishPage(payload.event.url)),
      filter(() => {
        const { extras } = this._router.getCurrentNavigation();
        const routerState = extras.state;
        const shouldClear = !(routerState && routerState.keepMessage);
        return shouldClear;
      }),
      map(() => appActions.clearMessages())
    )
  );
}
